'use client';

import { cn } from '@ahm/common-helpers';
import React, { type HTMLAttributes } from 'react';
import { useWebstoreSession } from './auth/webstore-session-provider';

export default function Container({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  const { expireAt, sessionCountdownHidden } = useWebstoreSession();

  const hasSessionCountdown =
    !!expireAt && expireAt > Date.now() / 1000 && !sessionCountdownHidden;

  return (
    <>
      <main
        className={cn(
          'w-full md:max-w-6xl max-w-lg mx-auto flex flex-col md:border-none border-x flex-1 bg-neutral-10 md:bg-white gap-3 pb-12 min-h-svh',
          hasSessionCountdown && 'pt-0', // Add padding-top when SessionCountdown is shown
          className
        )}
        {...props}
      >
        {children}
      </main>
    </>
  );
}
